import { AttributesConfigurationDc, ColumnDescriptionDc, PostgresLayerServiceConfigurationDc } from "@evergis/api";
import { LayerInfo } from "../../../interfaces/resourceInfo";
import { createLayerAttribute } from "../attributes/createLayerAttributes";

export function addColumnsToLayerConfiguration(
  layer: LayerInfo,
  columnsAdded: ColumnDescriptionDc[],
): PostgresLayerServiceConfigurationDc {
  const { layerAttributes, configuration, name } = layer || {};
  const { attributesConfiguration } = configuration || {};
  const newAttributes = columnsAdded.map(column => createLayerAttribute(column, true));

  return {
    ...configuration,
    name,
    attributesConfiguration: {
      ...(attributesConfiguration || {}),
      attributes: [...(layerAttributes || []), ...newAttributes],
    } as AttributesConfigurationDc,
  };
}
